import React from 'react';
import { format } from 'date-fns';
import { CalendarDays, MapPin, Package } from 'lucide-react';
import { getDumpster, formatCurrency } from '../../data/dumpsters';
import type { ReservationState } from './types';
import { Separator } from '../ui/Separator';
export function OrderSummary({
  state
}: {
  state: ReservationState;
}) {
  const dumpster = getDumpster(state.sizeId);
  return <div className="rounded-xl border border-border bg-secondary/40 p-5" data-id="element-11">
      <h3 className="text-sm font-semibold text-foreground" data-id="element-12">Order summary</h3>

      <div className="mt-4 space-y-3 text-sm" data-id="element-13">
        <div className="flex items-start gap-3" data-id="element-14">
          <Package className="mt-0.5 h-4 w-4 shrink-0 text-primary" data-id="element-15" />
          <div data-id="element-16">
            <p className="font-medium text-foreground" data-id="element-17">
              {dumpster ? `${dumpster.name} Dumpster` : 'No size selected'}
            </p>
            {dumpster && <p className="text-muted-foreground" data-id="element-18">
                {dumpster.rentalDays}-day rental · up to {dumpster.weightLimit}
              </p>}
          </div>
        </div>

        <div className="flex items-start gap-3" data-id="element-19">
          <CalendarDays className="mt-0.5 h-4 w-4 shrink-0 text-primary" data-id="element-20" />
          <p className="text-muted-foreground" data-id="element-21">
            {state.deliveryDate ? format(state.deliveryDate, 'EEEE, MMMM d, yyyy') : 'No delivery date selected'}
          </p>
        </div>

        {(state.address.street || state.address.city) && <div className="flex items-start gap-3" data-id="element-22">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" data-id="element-23" />
            <p className="text-muted-foreground" data-id="element-24">
              {state.address.street}
              {state.address.city && `, ${state.address.city}`}
              {state.address.state && `, ${state.address.state}`}{' '}
              {state.address.zip}
            </p>
          </div>}
      </div>

      {dumpster && <>
          <Separator className="my-4" data-id="element-25" />
          <div className="flex items-center justify-between text-base" data-id="element-26">
            <span className="font-medium text-foreground" data-id="element-27">Total</span>
            <span className="font-semibold text-foreground" data-id="element-28">
              {formatCurrency(dumpster.price)}
            </span>
          </div>
          <p className="mt-1 text-xs text-muted-foreground" data-id="element-29">
            All-in flat price. Taxes included.
          </p>
        </>}
    </div>;
}